// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: asset.proto

export const protobufPackage = 'compasspb';

/** Asset type enumeration */
export enum AssetType {
  ASSET_TYPE_UNSPECIFIED = 0,
  ASSET_TYPE_CALL_TRANSCRIPT = 1,
  ASSET_TYPE_CALL_RECORDING = 2,
  ASSET_TYPE_CALL_FULL_RECORDING = 3,
  ASSET_TYPE_CALL_DOCUMENT = 4,
  /** ASSET_TYPE_FAX - Fax document (PDF) */
  ASSET_TYPE_FAX = 5,
  /** ASSET_TYPE_USER_ATTACHMENT - File a user uploaded to a case input field (PDF) */
  ASSET_TYPE_USER_ATTACHMENT = 6,
}

/** Asset upload status */
export enum AssetUploadStatus {
  ASSET_UPLOAD_STATUS_UNSPECIFIED = 0,
  ASSET_UPLOAD_STATUS_PENDING = 1,
  ASSET_UPLOAD_STATUS_UPLOADING = 2,
  ASSET_UPLOAD_STATUS_UPLOADED = 3,
  ASSET_UPLOAD_STATUS_FAILED = 4,
  ASSET_UPLOAD_STATUS_COMPLETED = 5,
  ASSET_UPLOAD_STATUS_UPDATING = 6,
}

export interface ListAssetsRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  asset_type?: AssetType | undefined;
  call_id?: string | undefined;
}

export interface ListCallConsoleAssetsRequest {
  /** Organization ID */
  organization_id?: string | undefined;
  /** Program ID */
  program_id?: string | undefined;
  /** Case record the call belongs to */
  case_record_id?: string | undefined;
  /** Compass call ID */
  call_id?: string | undefined;
}

export interface ListCallConsoleAssetsResponse {
  /** Every Arcus asset of the call; asset_name tells them apart */
  assets?: Asset[] | undefined;
}

export interface DownloadCallConsoleAssetRequest {
  /** Organization ID */
  organization_id?: string | undefined;
  /** Program ID */
  program_id?: string | undefined;
  /** Case record the call belongs to */
  case_record_id?: string | undefined;
  /** Compass call ID */
  call_id?: string | undefined;
  /** Arcus asset ID; must belong to call_id */
  asset_id?: string | undefined;
  /** Optional HTTP Range header value */
  range_header?: string | undefined;
}

export interface DownloadCallConsoleAssetResponse {
  /** File data (the whole file, or the requested range) */
  data?: Uint8Array | undefined;
  /** MIME type of the file */
  content_type?: string | undefined;
  /** Total file size in bytes */
  total_size?: number | undefined;
  /** Arcus asset name */
  filename?: string | undefined;
  /** HTTP status code (200 for full, 206 for partial) */
  status_code?: number | undefined;
  /** Content-Range header value for partial responses */
  content_range?: string | undefined;
}

export interface ListAssetsResponse {
  assets?: Asset[] | undefined;
  /** @deprecated */
  total_count?: number | undefined;
}

export interface GetAssetRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  asset_id?: string | undefined;
  case_record_id?: string | undefined;
  call_id?: string | undefined;
}

export interface GetAssetResponse {
  asset?: Asset | undefined;
}

export interface DownloadAssetRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  asset_id?: string | undefined;
  case_record_id?: string | undefined;
  call_id?: string | undefined;
  /** HTTP Range header value for partial content requests */
  range_header?: string | undefined;
}

export interface DownloadAssetResponse {
  /** Complete file data */
  data?: Uint8Array | undefined;
  /** MIME type of the file */
  content_type?: string | undefined;
  /** Total file size in bytes */
  total_size?: number | undefined;
  /** Original filename */
  filename?: string | undefined;
  /** HTTP response metadata for headers */
  status_code?: number | undefined;
  /** Content-Range header value for partial responses */
  content_range?: string | undefined;
}

/**
 * DownloadAssetFromArcusRequest downloads an asset from Arcus encrypted storage
 * This is used for assets uploaded via Compass (not Twilio recordings via Atlas)
 */
export interface DownloadAssetFromArcusRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  asset_id?: string | undefined;
  call_id?: string | undefined;
  case_record_id?: string | undefined;
  /** HTTP Range header value for partial content requests */
  range_header?: string | undefined;
}

/** DownloadAssetFromArcusResponse contains the downloaded asset data from Arcus */
export interface DownloadAssetFromArcusResponse {
  /** Complete file data */
  data?: Uint8Array | undefined;
  /** MIME type of the file */
  content_type?: string | undefined;
  /** Total file size in bytes */
  total_size?: number | undefined;
  /** Original filename */
  filename?: string | undefined;
  /** HTTP response metadata for headers */
  status_code?: number | undefined;
  /** Content-Range header value for partial responses */
  content_range?: string | undefined;
}

/** UpdateAssetInArcusRequest contains asset data and metadata to update in Arcus */
export interface UpdateAssetInArcusRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  asset_id?: string | undefined;
  /** Complete file data */
  data?: Uint8Array | undefined;
  filename?: string | undefined;
  content_type?: string | undefined;
  case_record_id?: string | undefined;
  asset_type?: string | undefined;
  /** Optional metadata key-value pairs */
  metadata?: { [key: string]: string } | undefined;
}

export interface UpdateAssetInArcusRequest_MetadataEntry {
  key: string;
  value: string;
}

/** UpdateAssetInArcusResponse returns the result of the asset update */
export interface UpdateAssetInArcusResponse {
  asset_id?: string | undefined;
  bytes_uploaded?: number | undefined;
  status?: string | undefined;
  error_message?: string | undefined;
  content_type?: string | undefined;
  filename?: string | undefined;
}

/** CreateAssetRequest uploads a new file to Arcus and links it to a case record. */
export interface CreateAssetRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_record_id?: string | undefined;
  /** Complete file data (multipart part) */
  data?: Uint8Array | undefined;
  filename?: string | undefined;
  content_type?: string | undefined;
  asset_type?: string | undefined;
  field_id?: string | undefined;
}

/** CreateAssetResponse returns the newly created asset's ID and upload result. */
export interface CreateAssetResponse {
  asset_id?: string | undefined;
  bytes_uploaded?: number | undefined;
  status?: string | undefined;
  content_type?: string | undefined;
  filename?: string | undefined;
}

/** Asset represents a file asset stored in the system */
export interface Asset {
  /** Asset ID */
  id?: string | undefined;
  /** Atlas call ID (atlas_sid in case record) */
  call_id?: string | undefined;
  /** File path */
  path?: string | undefined;
  /** File size in bytes */
  size?: number | undefined;
  /** Type of asset */
  asset_type?: AssetType | undefined;
  /** MIME type */
  content_type?: string | undefined;
  /** Upload status */
  status?: AssetUploadStatus | undefined;
  /** Creation timestamp */
  created_at?: string | undefined;
  /** Last update timestamp */
  updated_at?: string | undefined;
  /** Human-readable name */
  asset_name?: string | undefined;
  /** Associated case record ID */
  case_record_id?: string | undefined;
  /** Complete local file path */
  file_path?: string | undefined;
  /** Error details if failed */
  error_message?: string | undefined;
  /** Completion timestamp */
  completed_at?: string | undefined;
}

/**
 * AssetsService provides operations for managing digital assets in the system.
 * Assets include call recordings, transcripts, and other files associated with
 * case records and calls. The service supports both Atlas (unencrypted) and
 * Arcus (encrypted) storage backends for enhanced security and compliance.
 */
export interface AssetService {
  /**
   * ListAssets retrieves all assets associated with a case record or call.
   * Returns asset metadata including file information, type, and storage location.
   */
  listAssets(request: ListAssetsRequest): Promise<ListAssetsResponse>;
  /**
   * GetAsset retrieves detailed metadata for a specific asset by its ID.
   * Returns comprehensive asset information including file properties and storage details.
   */
  getAsset(request: GetAssetRequest): Promise<GetAssetResponse>;
  /**
   * DownloadAsset retrieves the actual file content from Atlas storage.
   * Returns a presigned URL or direct download link for accessing the asset file.
   */
  downloadAsset(request: DownloadAssetRequest): Promise<DownloadAssetResponse>;
  /**
   * DownloadAssetFromArcus retrieves the file content from Arcus encrypted storage.
   * This method is used for assets uploaded via Compass that require HIPAA-compliant encryption.
   * Returns a presigned URL or direct download link for accessing the encrypted asset.
   */
  downloadAssetFromArcus(
    request: DownloadAssetFromArcusRequest,
  ): Promise<DownloadAssetFromArcusResponse>;
  /**
   * CreateAsset uploads a new file to Arcus encrypted storage and links it to a case record.
   * Used by the dashboard for immediate uploads on a File-type input field of an existing case
   * (the Link-to-Case and Tier-2 Update flows). The server detects the content type from the
   * file bytes and rejects anything that is not an allowed type (PDF only for user_attachment).
   * The upload itself reuses the same Arcus service path as UpdateAssetInArcus.
   */
  createAsset(request: CreateAssetRequest): Promise<CreateAssetResponse>;
  /**
   * UpdateAssetInArcus updates an existing asset in Arcus encrypted storage with new file content.
   * This method allows replacing the file content while maintaining the same asset ID and metadata.
   * Used for updating encrypted assets that require HIPAA-compliant storage.
   */
  updateAssetInArcus(request: UpdateAssetInArcusRequest): Promise<UpdateAssetInArcusResponse>;
  /**
   * ListCallConsoleAssets lists every Arcus asset the AI agent stored for a call:
   * rich transcript, session log, per-utterance audio, recording and the basic
   * transcript. It backs the internal Call Console and is gated only by the
   * global call_console permission, so customer roles never see these files.
   */
  listCallConsoleAssets(
    request: ListCallConsoleAssetsRequest,
  ): Promise<ListCallConsoleAssetsResponse>;
  /**
   * DownloadCallConsoleAsset streams one Call Console asset, with byte-range
   * support. The asset must belong to the call in the path.
   */
  downloadCallConsoleAsset(
    request: DownloadCallConsoleAssetRequest,
  ): Promise<DownloadCallConsoleAssetResponse>;
}
